import { FC } from 'react';

import { Box, Stack, Tooltip } from '@bonusly/design-system';

interface HeaderTooltipProps {
	children: any;
	isDisabled: boolean;
	names: string[];
}

export const HeaderTooltip: FC<HeaderTooltipProps> = ({ children, isDisabled, names }) => {
	const label = (
		<Stack spacing={0}>
			{names.map((name) => {
				return (
					<Box as="span" key={name}>
						{name}
					</Box>
				);
			})}
		</Stack>
	);

	return (
		<Tooltip isDisabled={isDisabled} label={label}>
			<Box
				as="span"
				{...(!isDisabled && {
					cursor: 'pointer',
					_hover: {
						textDecoration: 'underline',
					},
				})}
			>
				{children}
			</Box>
		</Tooltip>
	);
};
